/* eslint-disable no-debugger */
/* eslint-disable default-param-last */

import { Types as userConstants } from '../actions/actionType';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user } : {};

const authentication = (state = initialState, action) => {
    switch (action.type) {
    case userConstants.LOGIN_REQUEST:
        return {
            loggingIn: false,
            user: action.user,
        };
    case userConstants.LOGIN_SUCCESS:
        return {
            loggedIn: true,
            user: action.user,
        };
    case userConstants.LOGIN_FAILURE:
        return {};
    case userConstants.LOGOUT:
        return {};
    default:
        return state;
    }
};

export default authentication;
